import { useEffect, useState } from 'react'
import { get } from '../../../Services/api'

import './Money.css'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format'
import CostBreakdownChart from './CostBreakdownChart'

function DashboardMoney({ currentUser, userConfig }) {
    const days_week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

    const today = yyyy_mm_dd_date_format({})
    const [weekDates, setWeekDates] = useState([])
    const [timeFrame, setTimeFrame] = useState(7)

    const [costDetail, setCostDetail] = useState([])
    const [totalCost, setTotalCost] = useState()

    function getWeekDates() {
        const result = []
        for (let i = timeFrame - 1; i >= 0; i--) {
            const date = yyyy_mm_dd_date_format({ i_date: today, sub_days: i })
            const date_utc = new Date(date + "T00:00:00Z");
            result.push({
                day_of_week: days_week[date_utc.getUTCDay()],
                date: yyyy_mm_dd_date_format({ i_date: today, sub_days: i })
            })
        }

        setWeekDates(result);
    }


    useEffect(() => {
        // get week 
        if (userConfig)
            getWeekDates()
    }, [timeFrame, currentUser, userConfig])

    useEffect(() => {
        // get meal costs
        if (userConfig && weekDates.length)
            getUserMealCost()
    }, [weekDates])

    async function getUserMealCost() {
        const resp = await get("/api/meal-plan/get-user-meals-cost", {
            user_id: currentUser.uid,
            start_date: weekDates[0]?.date,
            end_date: today,
            country_code: userConfig.country_code
        })

        setTotalCost(resp.reduce((sum, item) => sum + parseInt(item.grand_total), 0))

        dataChartFormat(resp)
    }

    function dataChartFormat(data) {
        const result = []
        const groupedByDate = data.reduce((acc, meal) => {
            const date = meal.meal_date;
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(meal);
            return acc;
        }, {});


        if (timeFrame == 7) {
            getWeekDetail(weekDates, groupedByDate, result)
        } else if (timeFrame == 28) {
            getMonthDetail(weekDates, groupedByDate, result)
        }

        setCostDetail(result)
    }
    // get graph ready array for 7 days
    function getWeekDetail(weekDates, groupedByDate, result) {
        weekDates.map((day) => {
            let breakfast = 0, lunch = 0, dinner = 0, other = 0, total = 0

            const day_meals_cost = groupedByDate[day.date]

            day_meals_cost?.map((meal_cost) => {
                const meal_price = parseFloat(meal_cost.grand_total)
                total += meal_price
                switch (meal_cost.meal_course) {
                    case 'breakfast':
                        breakfast += meal_price
                        break;
                    case 'lunch':
                        lunch += meal_price
                        break;
                    case 'dinner':
                        dinner += meal_price
                        break;
                    default:
                        other += meal_price
                        break;
                }
            })
            result.push({
                label: day.day_of_week,
                data: {
                    breakfast: breakfast,
                    lunch: lunch,
                    dinner: dinner,
                    other: other,
                    total: total
                }
            })
        })
    }

    // get graph ready array for 28 days
    function getMonthDetail(weekDates, groupedByDate, result) {
        let weekGroup = [];
        let currentWeekIndex = 0;

        // Return month of date
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        function getDateMonth(dateString) {
            return months[parseInt(dateString.split("-")[1]) - 1]
        }
        // Group weekDates into 7-day intervals
        weekDates.map((day, i) => {
            weekGroup.push(day);
            if (weekGroup.length === 7 || i === weekDates.length - 1) {
                let breakfast = 0, lunch = 0, dinner = 0, other = 0, total = 0

                weekGroup.forEach((day) => {
                    const day_meals_cost = groupedByDate[day.date]
                    day_meals_cost?.map((meal_cost) => {
                        const meal_price = parseFloat(meal_cost.grand_total)
                        total += meal_price
                        switch (meal_cost.meal_course) {
                            case 'breakfast':
                                breakfast += meal_price
                                break;
                            case 'lunch':
                                lunch += meal_price
                                break;
                            case 'dinner':
                                dinner += meal_price
                                break;
                            default:
                                other += meal_price
                                break;
                        }
                    })
                });

                // Push the grouped data into the result array
                result.push({
                    label: weekGroup[0].date.split('-')[2] + ' - ' + weekGroup[weekGroup.length - 1].date.split('-')[2] + ' ' + getDateMonth(weekGroup[weekGroup.length - 1].date),
                    data: {
                        breakfast: breakfast,
                        lunch: lunch,
                        dinner: dinner,
                        other: other,
                        total: total
                    }
                });

                // Reset for the next group
                weekGroup = [];
                currentWeekIndex++;
            }
        })
    }

    return (
        <div className="component_padding black">
            <div className='dashboard-intake-overview-heading flex align_center justify_space_between'>
                <h4 className='font_family_ovo no_margin'>Expenses on Foods</h4>

                <div className="dashboard-intake-overview-range-picker-div">
                    <select className='dashboard-intake-overview-range-picker gray_scale_2' onChange={(e) => setTimeFrame(e.target.value)}>
                        <option value={7}>Last Week</option>
                        <option value={28}>Last 28 Days</option>
                    </select>
                    <svg
                        className="ashboard-intake-overview-range-picker-custom-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="none"
                        stroke="#5A5855"
                        strokeWidth="2"
                    >
                        <polyline points="5,7 10,12 15,7" />
                    </svg>
                </div>
            </div>

            <div className='component_heading_separating_line'></div>


            <div>
                <h2 className='font_family_ovo'>${totalCost} <span className='font_size_14 gray_scale_3 font_family_inter'>Total Spent</span></h2>
            </div>

            <div>
                <CostBreakdownChart details={costDetail} marginLeft={timeFrame == 7 ? 50 : 90} />
            </div>
        </div>
    );
}


export default DashboardMoney;